<template>
    <ul>
        <!-- eslint-disable-next-line -->
        <li v-if="param" v-for="(param, index) in data.split('\n')" :key="index">
            <b>{{param.split(';')[0]}}</b>: {{param.split(';')[1]}} <span v-if="param.split(';')[2]">({{param.split(';')[2]}})</span>
        </li>
    </ul>
</template>

<script>
    export default {
        props: [ "data" ]
    }
</script>

<style scoped>

</style>
